// „Tarif & Bezahlung“ (/rechnung/tarif); Inhalt in seiten/Tarif.tsx (erst bei Bedarf geladen)
import { faul } from './faul';

export const TarifSeite = faul(() => import('./seiten/Tarif'));
